import { Card } from "antd";
import { CardProps } from "antd/lib/card";
import classnames from "classnames";
import React from "react";

type Props = CardProps & {
  children: React.ReactNode;
  className?: string;
};

export default function Container({ children, className, ...props }: Props) {
  return (
    <Card
      className={classnames("container", className)}
      size="small"
      bodyStyle={{ paddingTop: 0, paddingBottom: 0 }}
      {...props}
    >
      {children}
    </Card>
  );
}
